import 'phaser';
import { CST } from '../CST';
import { Score } from '../controller/score.js';

var link;

export default class EndScreen extends Phaser.Scene {
	constructor() {
		super(CST.SCENES.ENDSCREEN);
	}

	preload() {
		// EndScreen popup assets — loaded here so they don't block the initial loading screen.
		// questionnaire-bg is also needed here (endscreen reuses it as a background).
		this.load.image('questionnaire-bg', 'assets/Questionnaire/Questionnaire - Background.png');
		this.load.image('bronze-popUp', 'assets/Endscreen - Popup - bronze.png');
		this.load.image('silver-popUp', 'assets/Endscreen - Popup - silver.png');
		this.load.image('gold-popUp', 'assets/Endscreen - Popup - gold.png');
		this.load.image('thanks-popUp', 'assets/thanks-for-playing.png');
	}

	create(data) {
		var styleQuestion = {
			fontFamily: 'Calibri',
			fontSize: 40,
			color: '#000000',
		};

		var clickSound = this.sound.add('click-sound', {
			volume: 0.5,
		});
		this.score = new Score(this);
		this.add.image(this.cameras.main.width / 2, this.cameras.main.height / 2, 'questionnaire-bg');

		if (this.score.showPoints() <= 49) {
			this.add
				.image(this.cameras.main.width / 2, this.cameras.main.height / 2, 'bronze-popUp')
				.setScale(0.8);
			this.add
				.text(
					this.cameras.main.width / 2 - 80,
					this.cameras.main.height / 2 + 145,
					'SCORE: ' + this.score.showPoints(),
					styleQuestion,
				)
				.setWordWrapWidth(800, true);
			this.add
				.text(
					this.cameras.main.width / 2 - 390,
					this.cameras.main.height / 2 + 195,
					'Uh oh. Sepertinya Anda bisa melakukan yang lebih baik. Coba lagi.',
					styleQuestion,
				)
				.setWordWrapWidth(800, true);
		} else if (this.score.showPoints() >= 50 && this.score.showPoints() <= 99) {
			this.add
				.image(this.cameras.main.width / 2, this.cameras.main.height / 2, 'silver-popUp')
				.setScale(0.8);
			this.add
				.text(
					this.cameras.main.width / 2 - 80,
					this.cameras.main.height / 2 + 145,
					'SCORE: ' + this.score.showPoints(),
					styleQuestion,
				)
				.setWordWrapWidth(800, true);
			this.add
				.text(
					this.cameras.main.width / 2 - 360,
					this.cameras.main.height / 2 + 195,
					'Tidak buruk! Coba lagi dan lihat apakah Anda bisa mendapatkan skor yang lebih tinggi.',
					styleQuestion,
				)
				.setWordWrapWidth(800, true);
		} else {
			this.add
				.image(this.cameras.main.width / 2, this.cameras.main.height / 2, 'gold-popUp')
				.setScale(0.8);
			this.add
				.text(
					this.cameras.main.width / 2 - 80,
					this.cameras.main.height / 2 + 145,
					'SCORE: ' + this.score.showPoints(),
					styleQuestion,
				)
				.setWordWrapWidth(800, true);
			this.add
				.text(
					this.cameras.main.width / 2 - 400,
					this.cameras.main.height / 2 + 195,
					'Bagus sekali! Anda telah mencapai standar emas!',
					styleQuestion,
				)
				.setWordWrapWidth(800, true);
		}

		this.certificate = this.add
			.image(
				this.cameras.main.width / 2 - 250,
				this.cameras.main.height / 2 + 335,
				'certificate-btn',
			)
			.setScale(0.8)
			.setInteractive({
				useHandCursor: true,
			})
			.on('pointerdown', () => {
				if (this.score.showPoints() <= 49) {
					link = 'assets/Certificates/bronze-certificate.pdf';
					openExternalLink(link);
				} else if (this.score.showPoints() >= 50 && this.score.showPoints() <= 99) {
					link = 'assets/Certificates/silver-certificate.pdf';
					openExternalLink(link);
				} else {
					link = 'assets/Certificates/gold-certificate.pdf';
					openExternalLink(link);
				}
			});

		this.feedback = this.add
			.image(this.cameras.main.width / 2, this.cameras.main.height / 2 + 335, 'feedback-btn')
			.setScale(0.8)
			.setInteractive({
				useHandCursor: true,
			})
			.on('pointerdown', () => {
				clickSound.play();
				link =
					'https://docs.google.com/forms/d/e/1FAIpQLSd8bf3kJEu-ioLFskHaPPAFDLKKTpNJFkSVEEs8nqtpHEvYgg/viewform';
				openExternalLink(link);
			});

		this.menu = this.add
			.image(this.cameras.main.width / 2 + 250, this.cameras.main.height / 2 + 335, 'menu-btn')
			.setScale(0.8)
			.setInteractive({
				useHandCursor: true,
			})
			.on('pointerdown', () => {
				clickSound.play();
				window.location.reload();
			});
	}
}

function openExternalLink(link) {
	window.open(link, '_blank');
}
